import { render, staticRenderFns } from "./No28.vue?vue&type=template&id=00e6546d&scoped=true"
import script from "./No28.vue?vue&type=script&lang=js"
export * from "./No28.vue?vue&type=script&lang=js"
import style0 from "./No28.vue?vue&type=style&index=0&id=00e6546d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e6546d",
  null
  
)

export default component.exports